import { useState, useEffect } from "react";
import { Dialog, DialogContent} from '@mui/material';
import { Button } from '@mui/material';
import { Divider } from '@mui/material';


export default function Portfolio() {
  const [photos, setPhotos] = useState([]);
  const [selectedPhoto, setSelectedPhoto] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  //const [password, setPassword] = useState("");
  const [loginError, setLoginError] = useState("");
  const [isAdmin, setIsAdmin] = useState(false);
  const [passwordInput, setPasswordInput] = useState("");
  const [editingPhoto, setEditingPhoto] = useState(null);

  useEffect(() => {
    fetch("/api/photos")
      .then((response) => response.json())
      .then((data) => setPhotos(data))
      .catch((error) => console.error("Error loading photos:", error));
  }, []);

  const currentIndex = selectedPhoto ? photos.findIndex(photo => photo.id === selectedPhoto.id) : -1;


  // Manages image either from uploaded file or url
  const MediaComponent = ({ photo }) => {
    const isVideo = (photo.image_data && photo.image_data.match(/\.(mp4|webm|ogg)$/i));

    if (isVideo) {
      const videoSrc = photo.image_data && photo.image_data !== "" ? photo.image_data : photo.image_url;
      return (
        <video
          controls
          src={videoSrc}
          className="w-full h-auto max-h-[60vh] object-contain rounded-lg mt-4"
        >
          Il tuo browser non supporta la riproduzione video.
        </video>
      );
    }

    const imageSrc = photo.image_data && photo.image_data !== "" ? photo.image_data : photo.image_url;

    return (
      <img
        src={imageSrc}
        alt={photo.title}
        className="w-full h-auto max-h-[60vh] object-contain rounded-lg mt-4"
      />
    );
  };
  

  const goToPrevious = () => {
    if (currentIndex > 0) {
      setSelectedPhoto(photos[currentIndex - 1]);
    }
  };

  const goToNext = () => {
    if (currentIndex < photos.length - 1) {
      setSelectedPhoto(photos[currentIndex + 1]);
    }
  };

  const handleLogin = async () => {
    const res = await fetch("/api/login", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ password: passwordInput }),
    });
    const result = await res.json();
    if (res.ok && result.auth === true) {
      console.log("Login success");
      setIsAdmin(true);
      console.log(isAdmin);
      setMenuOpen(false);
    } else {
      console.log("Login error");
      setLoginError("Incorrect password.");
    }
  }

  const handleLogout = async () => {
    await fetch("/api/logout", { method: "GET" }); // Rimuove il cookie lato server
    setIsAdmin(false);
    setMenuOpen(false);
  };


  const updatePhoto = async () => {
  try {
    const res = await fetch(`/api/photos/${editingPhoto.id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(editingPhoto),
    });

    if (!res.ok) {
      throw new Error("Errore durante l'aggiornamento della foto");
    }

    const updatedPhotos = photos.map(photo =>
      photo.id === editingPhoto.id ? editingPhoto : photo
    );
    setPhotos(updatedPhotos);
    setEditingPhoto(null);
    alert("Foto aggiornata con successo.");
  } catch (err) {
    console.error("Update error:", err);
    alert("Errore durante l'aggiornamento.");
  }
};

const deletePhoto = async (id) => {
  //if (!confirm("Sei sicuro di voler eliminare questa foto?")) return;

  try {
    const res = await fetch(`/api/photos/${id}`, {
      method: "DELETE",
    });

    if (!res.ok) {
      throw new Error("Errore durante la cancellazione della foto");
    }

    const updatedPhotos = photos.filter(photo => photo.id !== id);
    setPhotos(updatedPhotos);
    setEditingPhoto(null);
    alert("Foto eliminata con successo.");
  } catch (err) {
    console.error("Delete error:", err);
    alert("Errore durante l'eliminazione.");
  }
};


  return (
    <div className="p-4 max-w-md mx-auto">
      {/* Menu Bar */}
      <header className="flex justify-between items-center pb-4 border-b">
        <h1 className="text-lg font-bold"> </h1>
        <button className="text-lg right-0" onClick={() => setMenuOpen(true)}>☰</button>
      </header>

      {/* Menu Overlay */}
      {menuOpen && (
        <div className="fixed inset-0 bg-white z-50 flex flex-col items-center justify-center p-4">
          {/*<button className="absolute top-4 right-4 text-2xl" onClick={() => setMenuOpen(false)}>✖</button>}
          {/* X close button */}
          <button
                className="absolute top-2 right-2 text-black hover:text-red-700"
                onClick={() => setMenuOpen(false)}
              >
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
              </svg>
            </button>
          {/*TODO: <button classname="" onClick={window.location.href = "/upload"}>Upload page</button>*/}
          {isAdmin && (
            <>
              <h2 className="text-xl font-bold mb-4">Sei autenticato</h2>
              <button
                type="button"
                className="mt-4 text-white bg-red-600 hover:bg-red-700 focus:ring-4 focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2"
                onClick={() => handleLogout()} 
              >
                Logout
              </button>
            </>
          )}
          {!isAdmin && (
            <>
              <h2 className="text-xl font-bold mb-4">Admin Login</h2>
              <input
                type="password"
                placeholder="Enter password"
                className="border border-gray-300 p-2 rounded w-full max-w-xs mb-2"
                value={passwordInput}
                onChange={(e) => setPasswordInput(e.target.value)}
              />
              <button
                type="button"
                className="mt-4 text-gray-900 bg-white border border-gray-300 focus:outline-none hover:bg-gray-100 focus:ring-4 focus:ring-gray-100 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-gray-800 dark:text-white dark:border-gray-600 dark:hover:bg-gray-700 dark:hover:border-gray-600 dark:focus:ring-gray-700"
                onClick={handleLogin}
              >
                Login
              </button>
              {loginError && <p className="text-red-500 mt-2">{loginError}</p>}
            </>
          )}
        </div>
      )}

      {/* Info Section */}
      <section className="text-center my-6">
        <img src="/profilePic.jpg" alt="Photographer" className="w-32 h-32 rounded-full mx-auto" />
        <h2 className="text-xl font-bold mt-2">Giorgio Calcaterra</h2>
        <p className="text-gray-500">Bergamo, Italy</p>
        <div className="flex justify-center gap-2 mt-2">
          <button className="border p-2 rounded" onClick={() => window.location.href = 'mailto:22february.mp4@gmail.com'}>
            <img src="/email-1-svgrepo-com.svg" width="25" height="25" alt="mail" />
          </button>
          <button className="border p-2 rounded" onClick={() => window.open('https://instagram.com/giorgio.calcaterra', '_blank')}>
            <img src="/instagram-svgrepo-com.svg" width="20" height="15" alt="instagram" />
          </button>
          {/* LINKEDIN
            <button className="border p-2 rounded" onClick={() => window.open('', '_blank')}>
          <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0 0 50 50">
            <path d="M 9 4 C 6.2504839 4 4 6.2504839 4 9 L 4 41 C 4 43.749516 6.2504839 46 9 46 L 41 46 C 43.749516 46 46 43.749516 46 41 L 46 9 C 46 6.2504839 43.749516 4 41 4 L 9 4 z M 9 6 L 41 6 C 42.668484 6 44 7.3315161 44 9 L 44 41 C 44 42.668484 42.668484 44 41 44 L 9 44 C 7.3315161 44 6 42.668484 6 41 L 6 9 C 6 7.3315161 7.3315161 6 9 6 z M 14 11.011719 C 12.904779 11.011719 11.919219 11.339079 11.189453 11.953125 C 10.459687 12.567171 10.011719 13.484511 10.011719 14.466797 C 10.011719 16.333977 11.631285 17.789609 13.691406 17.933594 A 0.98809878 0.98809878 0 0 0 13.695312 17.935547 A 0.98809878 0.98809878 0 0 0 14 17.988281 C 16.27301 17.988281 17.988281 16.396083 17.988281 14.466797 A 0.98809878 0.98809878 0 0 0 17.986328 14.414062 C 17.884577 12.513831 16.190443 11.011719 14 11.011719 z M 14 12.988281 C 15.392231 12.988281 15.94197 13.610038 16.001953 14.492188 C 15.989803 15.348434 15.460091 16.011719 14 16.011719 C 12.614594 16.011719 11.988281 15.302225 11.988281 14.466797 C 11.988281 14.049083 12.140703 13.734298 12.460938 13.464844 C 12.78117 13.19539 13.295221 12.988281 14 12.988281 z M 11 19 A 1.0001 1.0001 0 0 0 10 20 L 10 39 A 1.0001 1.0001 0 0 0 11 40 L 17 40 A 1.0001 1.0001 0 0 0 18 39 L 18 33.134766 L 18 20 A 1.0001 1.0001 0 0 0 17 19 L 11 19 z M 20 19 A 1.0001 1.0001 0 0 0 19 20 L 19 39 A 1.0001 1.0001 0 0 0 20 40 L 26 40 A 1.0001 1.0001 0 0 0 27 39 L 27 29 C 27 28.170333 27.226394 27.345035 27.625 26.804688 C 28.023606 26.264339 28.526466 25.940057 29.482422 25.957031 C 30.468166 25.973981 30.989999 26.311669 31.384766 26.841797 C 31.779532 27.371924 32 28.166667 32 29 L 32 39 A 1.0001 1.0001 0 0 0 33 40 L 39 40 A 1.0001 1.0001 0 0 0 40 39 L 40 28.261719 C 40 25.300181 39.122788 22.95433 37.619141 21.367188 C 36.115493 19.780044 34.024172 19 31.8125 19 C 29.710483 19 28.110853 19.704889 27 20.423828 L 27 20 A 1.0001 1.0001 0 0 0 26 19 L 20 19 z M 12 21 L 16 21 L 16 33.134766 L 16 38 L 12 38 L 12 21 z M 21 21 L 25 21 L 25 22.560547 A 1.0001 1.0001 0 0 0 26.798828 23.162109 C 26.798828 23.162109 28.369194 21 31.8125 21 C 33.565828 21 35.069366 21.582581 36.167969 22.742188 C 37.266572 23.901794 38 25.688257 38 28.261719 L 38 38 L 34 38 L 34 29 C 34 27.833333 33.720468 26.627107 32.990234 25.646484 C 32.260001 24.665862 31.031834 23.983076 29.517578 23.957031 C 27.995534 23.930001 26.747519 24.626988 26.015625 25.619141 C 25.283731 26.611293 25 27.829667 25 29 L 25 38 L 21 38 L 21 21 z"></path>
          </svg>
          </button>*/}
        </div>
        <div className="grid gap-4 mt-4 text-sm text-center">
          <p><strong>Photographer | Director | Content Creator</strong></p>
        </div>
      </section>
      
      {/* Separator className="my-8"*/}
      <Divider className="mt-4" />
      
      {/* Portfolio Grid */}
      <div className="mt-8 grid grid-cols-2 gap-2">
        {/* Admin empty post*/}
        {isAdmin && (
            <div className="relative mt-4 flex items-center justify-center border border-dashed border-black h-32 cursor-pointer"
            onClick={() => {window.location.href = "/upload"}}
            >
              <span className="text-3xl">＋</span>
            </div>
          )}
        {photos.map((photo, index) => (
          <div
            key={photo.id}
            className={`relative cursor-pointer ${index % 2 === 0 ? 'mt-4' : ''}`}
            onClick={() => setSelectedPhoto(photo)}
          >
            {/* Admin edit option*/}
            {isAdmin && (
              <button
                className="absolute top-1 left-1 bg-white text-black rounded p-1 text-xs z-10 border"
                onClick={(e) => {
                  e.stopPropagation();
                  setEditingPhoto({ ...photo });
                }}
              >✎</button>
            )}
            <MediaComponent photo={photo} className="rounded-lg w-full h-auto"/>
          </div>
        ))}
      </div>
      
      {selectedPhoto && (
        <Dialog open={true} onOpenChange={() => setSelectedPhoto(null)}>
          <DialogContent className="p-4 text-center relative max-h-[81vh] overflow-hidden">
            {/* X close button */}
            <button
                className="absolute top-2 right-2 text-black hover:text-red-700"
                onClick={() => setSelectedPhoto(null)}
              >
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
              </svg>
            </button>

            {/* Left arrow (navigation) */}
            <button
              className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-black"
              onClick={goToPrevious}
              disabled={currentIndex === 0}
            >
              <svg class="w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 8 14">
               <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 1 1.3 6.326a.91.91 0 0 0 0 1.348L7 13"/>
              </svg>
            </button>
            {/* Right arrow (navigation) */}
            <button
              className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-black"
              onClick={goToNext}
              disabled={currentIndex === photos.length - 1}
            >
              <svg class="w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 8 14">
               <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 13 5.7-5.326a.909.909 0 0 0 0-1.348L1 1"/>
              </svg>
            </button>

            {/* Displayed img */}
            <div className="max-w-full max-h-[60vh] overflow-hidden p-2">
              <MediaComponent photo={selectedPhoto} alt={selectedPhoto.title} className="w-full h-auto max-h-[60vh] object-contain rounded-lg mt-4 " />
            </div>
            <h2 className="text-lg font-bold mt-2">{selectedPhoto.title}</h2>
            <h4 className="text-gray-500 flex items-center gap-1 justify-center">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5" />
              </svg>
              {selectedPhoto.date}
            
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                <path stroke-linecap="round" stroke-linejoin="round" d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z" />
              </svg>
              {selectedPhoto.location}
            </h4>
            <p>
              {selectedPhoto.description}
            </p>
            
            {/* View on IG button */}
            <div className="flex justify-center gap-2 mt-2">
              <button type="button" class="mt-4 text-gray-900 bg-white border border-gray-300 focus:outline-none hover:bg-gray-100 focus:ring-4 focus:ring-gray-100 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-gray-800 dark:text-white dark:border-gray-600 dark:hover:bg-gray-700 dark:hover:border-gray-600 dark:focus:ring-gray-700">
                <a href={selectedPhoto.link} target="_blank" rel="noopener noreferrer" className="dark:text-white inline-flex">View on Instagram
                <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"  viewBox="0 0 50 50" class="size-5 ml-1 fill-black">
                  <path d="M 16 3 C 8.8324839 3 3 8.8324839 3 16 L 3 34 C 3 41.167516 8.8324839 47 16 47 L 34 47 C 41.167516 47 47 41.167516 47 34 L 47 16 C 47 8.8324839 41.167516 3 34 3 L 16 3 z M 16 5 L 34 5 C 40.086484 5 45 9.9135161 45 16 L 45 34 C 45 40.086484 40.086484 45 34 45 L 16 45 C 9.9135161 45 5 40.086484 5 34 L 5 16 C 5 9.9135161 9.9135161 5 16 5 z M 37 11 A 2 2 0 0 0 35 13 A 2 2 0 0 0 37 15 A 2 2 0 0 0 39 13 A 2 2 0 0 0 37 11 z M 25 14 C 18.936712 14 14 18.936712 14 25 C 14 31.063288 18.936712 36 25 36 C 31.063288 36 36 31.063288 36 25 C 36 18.936712 31.063288 14 25 14 z M 25 16 C 29.982407 16 34 20.017593 34 25 C 34 29.982407 29.982407 34 25 34 C 20.017593 34 16 29.982407 16 25 C 16 20.017593 20.017593 16 25 16 z"></path>
                </svg>
                </a>
              </button>
              {/* View project page button */}
              <button type="button" class="flex mt-4 text-gray-900 bg-white border border-gray-300 focus:outline-none hover:bg-gray-100 focus:ring-4 focus:ring-gray-100 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-gray-800 dark:text-white dark:border-gray-600 dark:hover:bg-gray-700 dark:hover:border-gray-600 dark:focus:ring-gray-700"
                onClick={() => window.location.href = '/' + selectedPhoto.title.replace(/\s+/g, '-').toLowerCase() + '-' + selectedPhoto.id}>
                {/*<a href="" target="_blank" rel="noopener noreferrer" className="dark:text-white inline-flex">*/}
                  Project Page  
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 25 25" stroke-width="1.5" stroke="currentColor" class="size-5 ml-1">
                  <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 19.5 15-15m0 0H8.25m11.25 0v11.25" />
                </svg>
                {/*</a>*/}
              </button>
            </div>

          </DialogContent>
        </Dialog>
      )}

      {/* Edit Dialog */}
      {editingPhoto && (
        <Dialog open={true} onOpenChange={() => setEditingPhoto(null)}>
          {/* X close button */}
            <button
                className="absolute top-2 right-2 text-black hover:text-red-700"
                onClick={() => setEditingPhoto(null)}
              >
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
              </svg>
            </button>
          <DialogContent className="p-4 text-center">
            <input
              type="text"
              value={editingPhoto.title}
              onChange={(e) => setEditingPhoto({ ...editingPhoto, title: e.target.value })}
              className="border p-2 w-full mb-2"
            />
            <input
              type="text"
              value={editingPhoto.date}
              onChange={(e) => setEditingPhoto({ ...editingPhoto, date: e.target.value })}
              className="border p-2 w-full mb-2"
            />
            <input
              type="text"
              value={editingPhoto.location}
              onChange={(e) => setEditingPhoto({ ...editingPhoto, location: e.target.value })}
              className="border p-2 w-full mb-2"
            />
            <input
              type="text"
              value={editingPhoto.link}
              onChange={(e) => setEditingPhoto({ ...editingPhoto, link: e.target.value })}
              className="border p-2 w-full mb-4"
            />
            <input
              type="text"
              value={editingPhoto.description}
              onChange={(e) => setEditingPhoto({ ...editingPhoto, description: e.target.value })}
              className="border p-2 w-full mb-2"
            />
            <div className="flex gap-2">
              <Button onClick={updatePhoto} className="w-full">Save</Button>
              <Button onClick={() => deletePhoto(editingPhoto.id)} className="w-full bg-red-500 hover:bg-red-600">Delete</Button>
            </div>
          </DialogContent>
        </Dialog>
      )}
    </div>
  );
}
